import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

interface CollapsibleProps extends React.PropsWithChildren {
  open?: boolean;
  className?: string;
}

function Collapsible({ open = true, className, children }: CollapsibleProps) {
  const animationRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [animationHeight, setAnimationHeight] = useState<number>(10000);

  useEffect(() => {
    const updateHeight = () => {
      if (animationRef.current) {
        setAnimationHeight(animationRef.current.scrollHeight + 100);
      }
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div
      ref={animationRef}
      onTransitionStart={() => setIsAnimating(true)}
      onTransitionEnd={() => setIsAnimating(false)}
      style={{
        maxHeight: open ? animationHeight : 0,
        overflow: !open || isAnimating ? 'hidden' : '',
      }}
      className={classNames(
        'transition-maxHeight duration-1000',
        className,
        !open && 'overflow-hidden',
        isAnimating && 'overflow-hidden'
      )}
    >
      {children}
    </div>
  );
}

export default Collapsible;
